<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<main>
    <app-ds-banner></app-ds-banner>
    <div class="tw-py-[50px] lg:tw-py-[100px]">
        <div
            class="tw-max-w-[1280px] tw-px-[25px] md:tw-px-[30px] xl:tw-px-0 tw-mx-auto"
        >
            <h3
                class="!tw-text-[#0F3172] !tw-text-[22px] md:!tw-text-[28px] !tw-font-bold"
            >
                {{ "DIGITAL_SERVICES.SUB_TITLE" | translate }}
            </h3>
            <p class="!tw-text-[#1A202C] !tw-text-[14px]">
                {{ "DIGITAL_SERVICES.SUB_DESC_1" | translate }}
            </p>
            <p class="!tw-text-[#1A202C] !tw-text-[14px]">
                {{ "DIGITAL_SERVICES.SUB_DESC_2" | translate }}
            </p>
        </div>
    </div>
    <app-ds-services></app-ds-services>
    <app-ds-service-listing
        [selectedLanguage]="selectedLanguage"
        [digiServiceData]="digiServiceData"
        (openDigiPartnershipDialog)="openDigiPartnershipDialog($event)"
    ></app-ds-service-listing>
</main>

<app-footer [selectedLanguage]="selectedLanguage" />
